module.exports = __webpack_public_path__ + "static/media/sr-group.c9599732.svg";